// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ForSorting_checkbox__3Skdm","checkedCheckbox":"ForSorting_checkedCheckbox__36jK8","sortingBox":"ForSorting_sortingBox__xGpuR"};